import React from 'react'
import { useNavigate } from 'react-router-dom'; // Import useHistory hook
import {
    Avatar,
    Box,
    Button,
    ButtonGroup,
    Container,
    HStack,
    Icon,
    IconButton,
    Image,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Switch,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useColorMode, Tooltip

} from '@chakra-ui/react'
import { FiBell } from 'react-icons/fi'
import { DocumentPopover } from './DocumentPopover'
import logo_movil_light from '../../assets/logo_movil_light.png';
import logo_movil_dark from '../../assets/logo_movil_dark.png';
import { MobileDrawer } from './MobileDrawer'
import { useAuth } from '../../context/AuthContext';
import { AiOutlineUser } from 'react-icons/ai';
import { FiMoon } from 'react-icons/fi';
import { useState } from 'react';
import { useGlobalContext } from '../../context/GlobalContext';


const Navbar = () => {
    const { toggleColorMode, colorMode } = useColorMode();
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const onClose = () => setIsOpen(false);
    const cancelRef = React.useRef();

    const { userDetails, logout } = useAuth();
    const [{ config }] = useGlobalContext();

    const logoutDialog = () => {
        setIsOpen(true);
    };

    const handleLogout = () => {
        logout();
        setIsOpen(false);
    };

    const darkMode = () => {
        toggleColorMode();
    };

    const handleNavigation = (route) => {
        if (!config?.inOperation) {
            navigate(route);
        } else {
            alert('Esta en operación activa, termine la operación para poder acceder a esta sección');
        };
    };
    return (
        <Box borderBottomWidth="1px" bg="bg.surface" position="relative" zIndex="tooltip">
            <Container py="4" maxW='100%'>
                <HStack justify="space-between" spacing="8">
                    <HStack spacing="10">
                        <HStack spacing="3">
                            <MobileDrawer />
                            <Box onClick={() => navigate('/dashboard')}>

                                {userDetails?.logo ? (
                                    <Image
                                        src={colorMode === 'light' || !userDetails?.logoDark ? userDetails?.logo : userDetails?.logoDark}
                                        w="200px"
                                        style={colorMode === 'dark' && !userDetails?.logoDark ? { filter: 'invert(100%)' } : {}}
                                    />
                                ) : (
                                    colorMode === 'light' ? <Image src={logo_movil_light} w="100px" /> :
                                        <Image src={logo_movil_dark} w="100px" />
                                )}
                            </Box>
                        </HStack>
                        <ButtonGroup
                            size="lg"
                            variant="text"
                            colorScheme="gray"
                            spacing="8"
                            display={{
                                base: 'none',
                                lg: 'flex',
                            }}
                            cursor="pointer"
                        >

                            <Button onClick={() => handleNavigation('/dashboard')} >Tablero</Button>
                            <Button onClick={() => handleNavigation('/operations')}>Operaciones</Button>
                            {/* <Button onClick={() => navigate('/print')}>Impresión</Button> */}
                            <DocumentPopover />
                            {userDetails?.rol === "superadmin" && <Button>Administracion</Button>}
                            {/*  <Button>Reportes</Button> */}
                        </ButtonGroup>
                    </HStack>
                    <HStack
                        spacing={{
                            base: '2',
                            md: '4',
                        }}
                    >
                        {/* <InputGroup
                            maxW="2xs"
                            display={{
                                base: 'none',
                                md: 'inline-flex',
                            }}
                        >
                            <InputLeftElement>
                                <Icon as={FiSearch} color="fg.muted" fontSize="lg" />
                            </InputLeftElement>
                            <Input placeholder="Buscar" />
                        </InputGroup> */}
                        <ButtonGroup variant="tertiary" spacing="1">
                            {/* <IconButton
                                icon={<FiSearch />}
                                aria-label="Serach"
                                display={{
                                    base: 'flex',
                                    lg: 'none',
                                }}
                                isRound
                            /> */}
                            <IconButton icon={<FiBell />} aria-label="Show notification" isRound />
                        </ButtonGroup>
                        <Menu>
                            <Tooltip label={userDetails.email} hasArrow>
                                <MenuButton as={IconButton} icon={<Avatar name={userDetails?.name} icon={<AiOutlineUser fontSize='1.5rem' />} />} />
                            </Tooltip>
                            <MenuList>
                                <MenuItem onClick={logoutDialog}>Salir</MenuItem>
                                <MenuItem>
                                    <HStack spacing="2">
                                        <Icon as={FiMoon} />
                                        <Switch size="sm" onChange={darkMode} />
                                    </HStack>
                                </MenuItem>
                            </MenuList>
                        </Menu>

                    </HStack>
                </HStack>
            </Container>
            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Confirma salir
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            ¿Esta seguro que quiere salir?
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button colorScheme="red" onClick={handleLogout} ml={3}>
                                Salir
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>

    );
};

export default Navbar;